import React from 'react'

const CTA = ({ openResumeModal }) => {
  return (
    <div className='cta'>
        <a href="#contact" className='btn'>Let's Talk</a>
        <button onClick={openResumeModal} className='btn btn-primary'>View My Resume</button>
    </div>
  );
}

export default CTA;